import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

const Cell = ({ extraClasses, children, ...otherProps }) => (
  <div className={classnames('cell', extraClasses)} {...otherProps}>
    {children}
  </div>
)

Cell.propTypes = {
  children: PropTypes.any.isRequired,
  extraClasses: PropTypes.string
}

Cell.defaultProps = { extraClasses: '' }

export default Cell
